// A room page the Mac has and the web doesn't yet: its name, a line saying so, and its Help article.
import type { PageProps } from '../shell/ProjectShell.tsx';
import { followLink } from '../shell/route.ts';

export function PlaceholderPage({ page }: PageProps) {
  const help = page.help ? `/help/${page.help}` : null;
  return (
    <div className="placeholder-page" data-placeholder={`${page.room}/${page.page}`}>
      <header className="page-head">
        <h1 tabIndex={-1}>{page.title}</h1>
      </header>
      <p className="lede">
        {page.title} is on your Mac and iPad, and is coming to the web. What you do with it there is kept in the project, so nothing is lost here.
      </p>
      {help ? (
        <p>
          <a href={help} onClick={(e) => followLink(e, help)}>
            About {page.title} in Help
          </a>
        </p>
      ) : null}
    </div>
  );
}
